import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        surveyGroup: '=',
        bulkIds: '=',
        isGroupDeadlinePassed: '=',
        classifiers: '=',
        sites: '=',
        reload: '&'
    },
    template: `
        <div class="heading01">
            <h2>{{ 'survey.Participants' | translate }}</h2>
            <ul class="actions01">
                <li class="separated">
                    <a
                        class="btn add"
                        ng-if="!vm.isGroupDeadlinePassed && !vm.isCourseSurvey"
                        ng-click="vm.addParticipants()"
                    >{{ 'survey.Add participants' | translate }}</a>
                </li>
            </ul>
        </div>
        <list-empty list="vm.surveyGroup.sortedByNameParticipants" show-add-message="true"></list-empty>
        <table
            class="data01"
            ng-init="vm.initBulk()"
            datatable
            dt-options="vm.DATATABLES"
            ng-if="vm.surveyGroup.sortedByNameParticipants.length && !vm.loading"
            >
            <thead>
            <tr>
                <th class="w1p" ng-if="!vm.isGroupDeadlinePassed && !vm.isCourseSurvey">
                    <input ng-click="vm.toggleAll()" ng-model="vm.checked" type="checkbox">
                </th>
                <th>{{ 'survey.First name' | translate }}</th>
                <th>{{ 'survey.Last name' | translate }}</th>
                <th>{{ 'survey.Status' | translate }}</th>
                <th>{{ 'survey.Last reminder' | translate }}</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tr ng-repeat="item in vm.surveyGroup.sortedByNameParticipants" ng-init="user=vm.surveyGroup.users[item.userId]">
                <td class="w1p" ng-if="!vm.isGroupDeadlinePassed && !vm.isCourseSurvey">
                    <input
                        type="checkbox"
                        ng-if="item.status!==vm.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.COMPLETED"
                        ng-checked="vm.hasParticipant(item.id)"
                        ng-click="$event.stopPropagation();vm.toggleParticipant(item.id)"
                    />
                </td>
                <td><a>{{ user.firstName }}</a></td>
                <td><a>{{ user.lastName }}</a></td>
                <td>
                    <span class="status {{vm.getStatusClass(item.status)}}">{{ vm.SURVEY_PARTICIPANT_STATUS_ENUM.LABELS[item.status] }}</span>
                </td>
                <td>
                    <span ng-if="item.lastReminderSentAt">{{ vm.MomentService.formatTimeStamp(item.lastReminderSentAt, 'DD.MM.YYYY') }}</span>
                </td>
                <td class="actions">
                    <a
                        class="btn delete"
                        ng-if="vm.isParticipantRemovable(item) && !vm.SurveyGroupService.isCourseSurveyType(vm.surveyGroup)"
                        ng-click="vm.removeParticipant(item.id, user.displayName)"
                        >
                        {{ 'general.Remove' | translate }}
                    </a>
                </td>
            </tr>
        </table>
    `
})
export default class {
    constructor ($translate, lodash, toastr, DATATABLES, MomentService, ModalService, SurveyGroupService, SurveyGroupResource,
                 SURVEY_PARTICIPANT_STATUS_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.SurveyGroupService = SurveyGroupService;
        this.SurveyGroupResource = SurveyGroupResource;
        this.SURVEY_PARTICIPANT_STATUS_ENUM = SURVEY_PARTICIPANT_STATUS_ENUM;
    }

    $onInit () {
        this.isCourseSurvey = this.SurveyGroupService.isCourseSurveyType(this.surveyGroup);
    }

    getStatusClass (status) {
        let statusClass = '';
        switch (status) {
        case this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.NOTIFICATION_NOT_SENT:
            statusClass = 'status-error';
            break;
        case this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.NOT_STARTED:
        case this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.NOT_COMPLETED:
            statusClass = 'status-warn';
            break;
        default:
            statusClass = 'status-ok';
        }
        return statusClass;
    }

    isParticipantRemovable (participant) {
        return participant.status !== this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.COMPLETED
            && !this.isGroupDeadlinePassed
        ;
    }

    hasParticipant (key) {
        return this.lodash.includes(this.bulkIds, key);
    }

    toggleParticipant (key) {
        if (this.hasParticipant(key)) {
            this.lodash.pull(this.bulkIds, key);
            this.checked = false;
        }
        else {
            this.bulkIds.push(key);
        }
    }

    toggleAll () {
        const allParticipants = this.surveyGroup.sortedByNameParticipants.filter((participant) => {
            return participant.status !== this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.COMPLETED;
        });
        this.bulkIds = this.checked ? allParticipants.map((participant) => participant.id) : [];
    }

    initBulk () {
        this.bulkIds = [];
        this.checked = false;
    }

    addParticipants () {
        const { surveyGroup, classifiers, sites } = this;
        this.ModalService.open({
            animation: true,
            size: 'xlarge',
            template: `
                <modals-survey-participant
                    survey-group="vm.surveyGroup"
                    classifiers="vm.classifiers"
                    sites="vm.sites"
                    uib-modal-instance="vm.$uibModalInstance"
                    class="wrapper"
                />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.surveyGroup = surveyGroup;
                this.classifiers = classifiers;
                this.sites = sites;
            }
        }).then(() => {
            this.reload().then((updatedSurveyGroup) => {
                this.surveyGroup = updatedSurveyGroup;
            });
        });
    }

    removeParticipant (participantId, name) {
        this.ModalService.confirm(this.$translate.instant('survey.Remove participant {name}?', { name }), 'medium')
            .then(() => {
                this.SurveyGroupResource.removeParticipants(
                    { id: this.surveyGroup.id }, { ids: [participantId] }
                ).$promise
                    .then(() => {
                        this.toastr.success(this.$translate.instant('survey.Participant removed'));
                        this.reload().then((updatedSurveyGroup) => {
                            this.surveyGroup = updatedSurveyGroup;
                        });
                    });
            })
            .catch((response) => {
                this.toastr.error(response.data[0].message);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/detail/participants/index.js